export const GAME_CREATE_RESET = 'GAME_CREATE_RESET'
export const GAME_CREATE_SET_CREATED = 'GAME_CREATE_SET_CREATED'
export const GAME_CREATE_SET_ERROR = 'GAME_CREATE_SET_ERROR'
export const GAME_CREATE_SET_VIOLATIONS = 'GAME_CREATE_SET_VIOLATIONS'
export const GAME_CREATE_TOGGLE_LOADING = 'GAME_CREATE_TOGGLE_LOADING'
